import { Component, OnInit } from '@angular/core';
import { SellerService } from '../services/sellers/seller.service';
import { Router } from '@angular/router';


import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';
import { Auth } from '../services/auth.service';

@Component({
  selector: 'seller',
  templateUrl: './seller.component.html',
  styleUrls: ['../users/users.component.css']
})
export class SellerComponent extends UsersComponent {
  constructor(
    protected router: Router,
    protected sellerService: SellerService,
    protected providerService: ProviderService,
    protected auth: Auth) { super(router, sellerService, providerService); }

    selectedProviderIndex: string
    hasBOUsersPermission: Boolean = false;

  protected getDetailUrl(): string {

    return '/seller/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'seller';
  };

  protected getUsersString(): string {

    return 'Sellers';
  };

  ngOnInit(): void {
    this.getUsers({ limit: this.usersPerGet })
    this.getProviders();
    this.hasBOUsersPermission = this.auth.hasBOUsersPermission();
  }

  add(): void {

    if (this.createCalled) {

      return;
    }
    if (this.newUser.name == undefined || this.newUser.password == undefined || this.newUser.email == undefined) {
      this.alertAdd = true;
      return;
    }
    let name = this.newUser.name.trim();
    if (!name) {
      this.alertAdd = true;
      return;
    }

    let password = this.newUser.password.trim();

    let email = this.newUser.email.trim();
    if (!email) {
      this.alertAdd = true;
      return;
    }

    this.createCalled = true;
    this.sellerService.create({
      name: name,
      password: password,
      email: email,
      provider: this.providers[this.selectedProviderIndex].id
    })
      .then(user => {

        this.createCalled = false;
        this.pushOrdered(user);
        this.selectedUser = null;
        this.newUser = {};
        this.configPages()
        this.alertCreated = true;
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        alert(error.message)
        return Promise.reject(error.message || error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/seller/seller.component.ts